import { render, staticRenderFns } from "./SmsMessage.vue?vue&type=template&id=d32f63b6&"
import script from "./SmsMessage.vue?vue&type=script&lang=js&"
export * from "./SmsMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports